import React from 'react';
import FeatherIcon from 'components/custom/FeatherIcon';
import { toast } from 'react-toastify';
import defaultTheme from 'constants/themes/defaultTheme';
import IntlMessages from './IntlMessages';
import IntlHtmlMessages from './IntlHtmlMessages';

export const showError = ( message, { id, translate = false } = {} ) => toast.error(
  <span className="d-flex align-items-center">
    <FeatherIcon
      className="mr-2"
      icon="xCircle"
      size="35px"
      color="error.main"
    />
    {translate ? <IntlMessages id={message} /> : message}
  </span>,
  {
    id,
    icon: false,
    progressStyle: {
      height: '2px',
      backgroundColor: defaultTheme.palette.error.main,
    },
    bodyStyle: { padding: 0 },
    style: { fontSize: '12px', fontWeight: 500 },

    autoClose: 6000,
  },
);
export const showLoading = (
  message,
  { id, translate = false, messageValues } = {},
) => toast.loading(
  <span className="d-flex align-items-center">
    <FeatherIcon
      className="mr-2 animate__animated animate__rotateIn animate__infinite"
      icon="loader"
      size="35px"
      color="primary.light"
    />
    {translate ? (
      <IntlHtmlMessages id={message} values={messageValues} />
    ) : (
      message
    )}
  </span>,
  {
    toastId: id,
    icon: false,
    progressStyle: {
      height: '2px',
      backgroundColor: defaultTheme.palette.primary.main,
    },
    bodyStyle: { padding: 0 },
    style: { fontSize: '12px', fontWeight: 500 },
    closeButton: true,
    autoClose: false,
  },
);
export const showSuccess = (
  message,
  { id, translate = false, messageValues } = {},
) => toast.error(
  <span className="d-flex align-items-center">
    <FeatherIcon
      className="mr-2  "
      icon="checkCircle"
      size="32px"
      color="primary2.main"
    />
    {translate ? (
      <IntlHtmlMessages id={message} values={messageValues} />
    ) : (
      message
    )}
  </span>,
  {
    toastId: id,
    icon: false,
    progressStyle: {
      height: '2px',
      backgroundColor: defaultTheme.palette.primary2.main,
    },
    bodyStyle: { padding: 0 },
    style: { fontSize: '12px', fontWeight: 500 },

    autoClose: 5000,
  },
);
